<template>
  <div
    class="notification is-primary"
    :class="[{'fullwidth': fullWidth}, {visible: visible}, cssClass, position]"
  >
    <button
      v-if="dismissible"
      class="delete"
      @click="clickClose"
    />
    <p v-html="message" />
  </div>
</template>
<script>
export default {
  name: 'ToastComponent',
  data() {
    return {
      message: '',
      cssClass: 'is-info',
      duration: -1,
      position: 'bottom-right',
      dismissible: true,
      visible: false,
      fullWidth: false,
      toastQueue: []
    };
  },
  mounted() {
    const self = this;
    this.$root.$on('showToast', (data) => {
      if ('message' in data) {
        const options = ('options' in data) ? data.options : {};
        self.showToast(data.message, options);
      }
    });
    this.$root.$on('setToastQueue', (data) => {
      self.toastQueue.push(data);
    });
    this.$root.$on('checkToastQueue', (name) => {
      self.checkAndShowToast(name);
    });
  },
  methods: {
    clickClose(e) {
      e.preventDefault();
      this.close();
    },
    close() {
      this.visible = false;
      const self = this;
      setTimeout(() => {
        self.message = '';
        self.cssClass = 'is-info';
        self.position = 'bottom-right';
        self.dismissible = true;
        self.fullWidth = false;
      }, 300);
    },
    // eslint-disable-next-line default-param-last
    showToast(message, options = {}, callback) {
      const delay = this.visible ? 300 : 0;
      const self = this;

      if (!message) {
        this.close();
      } else {
        if (this.visible) {
          this.close();
        }
        setTimeout(() => {
          self.message = message;
          if ('cssClass' in options) self.cssClass = options.cssClass;
          if ('position' in options) self.position = options.position;
          if ('dismissible' in options) self.dismissible = options.dismissble;
          if ('fullWidth' in options) self.fullWidth = options.fullWidth;
          self.visible = true;

          if ('duration' in options) {
            setTimeout(() => {
              self.close();
            }, options.duration);
          }
          if (typeof callback === 'function') {
            callback();
          }
        }, delay);
      }
    },
    checkAndShowToast(name) {
      const { toastQueue } = this;
      const existingToastIndex = toastQueue.findIndex((toast) => toast.name === name);

      if (existingToastIndex === -1) {
        return;
      }
      const { message, options } = toastQueue[existingToastIndex].data;
      this.showToast(message, options, () => this.toastQueue.splice(existingToastIndex, 1));
    }
  }
};
</script>
<style scoped>
    .notification {
        position: fixed;
        z-index: 1000;
        display: inline-block;
        opacity:0;
        pointer-events: none;
        transition: .3s ease-in-out;
    }

    .notification.fullwidth {
        width: calc(100% - 20px);
    }

    .notification.visible {
        opacity: 1;
        pointer-events: auto;
        transition: .3s ease-in-out;
    }

    .notification.top-left{
        top: 10px;
        left: 10px;
    }

    .notification.top-right {
        top: 10px;
        right:10px;
    }

    .notification.bottom-left {
        bottom: 10px;
        left:10px;
    }

    .notification.bottom-right {
        bottom: 10px;
        right: 10px;
    }

    .notification.center {
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .notification.top-center {
        top: 10px;
        left: 50%;
        transform: translateX(-50%);
    }

    .notification.bottom-center {
        bottom: 10px;
        left: 50%;
        transform: translateX(-50%);
    }
</style>
